import { Box, Spacer, Stack, Text } from '@chakra-ui/react'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import KhanAcademyIcon from '@/components/Icons/KhanAcademyIcon'
import ShwLink from '@/components/ShwLink'

import ProfileItemContainer from './ProfileItemContainer'

export default function ProfileKhanAcademyUsername({
  user,
}: {
  user: Query
}): React.ReactElement | null {
  const khanAcademyUsername = user`${UserQ.internal_state}->'khan_academy'->>'username'`
  return khanAcademyUsername == null ? null : (
    <Box>
      <ShwLink width="100%" href={`https://khanacademy.org/profile/${khanAcademyUsername}`}>
        <ProfileItemContainer>
          <Stack direction="row" spacing="16px" align="center">
            <KhanAcademyIcon
              style={{
                height: '48px',
                width: 'auto',
                marginRight: '10px',
              }}
            />
            <Box>
              <Text variant="eyebrow" mb={2}>
                Khan Academy Profile
              </Text>
              <Text fontWeight={600}>{khanAcademyUsername}</Text>
            </Box>
            <Spacer />
            <Text color="fg.subtle">
              <FontAwesomeIcon icon={faChevronRight} />
            </Text>
          </Stack>
        </ProfileItemContainer>
      </ShwLink>
    </Box>
  )
}
